export const BOOK_IT = "bookIt";
export const SUCCESSWARE_PAY = "successwarePay";

export const SUCCESSWARE_PAY_PATTERN = /^swpay/;
export const BOOK_IT_PATTERN = /^clink/;